import { getMessage } from '@tcc/i18n';
import { Button, ButtonFill, ComponentColor, Dialog, DialogContent, DialogFooter, DialogWidth, Typography, TypographyVariant } from '@tcc/fds';

export interface FdsConfirmationModalProps {
  handleClickGoBack: () => void;
  handleClickCancel: () => void;
  modalTitle?: string;
  title?: string;
  subTitle?: string;
  dialogTestId: string;
}

export const FdsConfirmationModal  = ({
  dialogTestId,
  handleClickGoBack,
  handleClickCancel,
  modalTitle,
  title,
  subTitle,
}: FdsConfirmationModalProps) => (
  <Dialog
    testId={dialogTestId}
    key={dialogTestId}
    onOpenChange={handleClickGoBack}
    defaultOpen
    open
    isModal
    width={DialogWidth.Wide}
    closeOnOutsideClick={false}
    headerProps={{
      showCloseButton: true,
      title: modalTitle === undefined ? getMessage('regions.report.modal.title') : modalTitle
    }}>
  <DialogContent>
    <Typography variant={TypographyVariant.Heading}>
      { title === undefined ? getMessage('regions.report.modal.confirm.close') : title}
    </Typography>
    <Typography variant={TypographyVariant.Body}>
      {subTitle === undefined ? getMessage('regions.report.modal.confirm.close.subheading') : subTitle}
    </Typography>
  </DialogContent>
  <DialogFooter>
    <Button
      testId='confirmation-modal-go-back-button'
      onClick={handleClickGoBack}
      fill={ButtonFill.Outline}
      color={ComponentColor.Primary}>
        {getMessage('confirmationModal.goBack')}
    </Button>
    <Button
      testId='confirmation-modal-confirm-button'
      onClick={handleClickCancel}
      fill={ButtonFill.Solid}
      color={ComponentColor.Primary}>
        {getMessage('regions.report.modal.close')}
    </Button>
  </DialogFooter>
  </Dialog>
);
